import { set, useCurrentElement } from "@vueuse/core";
import { type MaybeRefOrGetter, ref, shallowRef, toValue, watch } from "vue";

function useConfiguratorSlide() {
	const currentElement = useCurrentElement<HTMLElement>();
	const parentElement = shallowRef<HTMLElement | null>(currentElement.value?.closest("y-configurator-slide") ?? null);

	watch(currentElement, (element) => {
		set(parentElement, element.closest("y-configurator-slide") ?? null);
	});

	return { slideElement: parentElement };
}

export function useSlideDataset(datasetKey: MaybeRefOrGetter) {
	const { slideElement } = useConfiguratorSlide();
	const datasetValue = shallowRef<string | undefined>(undefined);
	const dataSetKeyValue = toValue(datasetKey);

	if (slideElement.value?.dataset && Object.hasOwn(slideElement.value.dataset, dataSetKeyValue)) {
		set(datasetValue, slideElement.value.dataset[dataSetKeyValue]);
	}

	watch(slideElement, () => {
		if (slideElement.value?.dataset && Object.hasOwn(slideElement.value.dataset, dataSetKeyValue)) {
			set(datasetValue, slideElement.value.dataset[dataSetKeyValue]);
		}
	});

	return { datasetValue, datasetKey };
}

export function useSlideDatasetFull() {
	const { slideElement } = useConfiguratorSlide();
	const dataset = ref(slideElement.value?.dataset);

	watch(slideElement, (): void => {
		set(dataset, slideElement.value?.dataset);
	});

	return { dataset };
}
